import React from "react";
import { useNavigate } from "react-router-dom";
import { LuLock } from "react-icons/lu";
import { Button, Dialog } from "../components/ui";
import { t } from "../i18n";
import { PATHS } from "./paths";

interface UpgradeDialogProps {
  message: string;
  onClose: () => void;
}

/** Aberto pelo evento global de upgrade (403 de plano) com a mensagem do backend. */
export const UpgradeDialog: React.FC<UpgradeDialogProps> = ({ message, onClose }) => {
  const navigate = useNavigate();
  const goToPlans = () => {
    onClose();
    navigate(PATHS.plans);
  };

  return (
    <Dialog
      open
      onClose={onClose}
      size="sm"
      title={
        <span className="flex items-center gap-2">
          <LuLock className="text-warning" aria-hidden />
          {t("upgrade.title")}
        </span>
      }
      description={message}
      footer={
        <div className="flex w-full flex-col gap-2">
          <Button variant="primary" size="lg" fullWidth onClick={goToPlans}>{t("upgrade.cta")}</Button>
          <Button variant="outline" fullWidth onClick={onClose}>{t("upgrade.close")}</Button>
        </div>
      }
    />
  );
};
